<template>
  <dv-border-box-9>
    <h2 class="title">仪器数量柱状图</h2>
    <div ref="barChart" style="width: 600px; height: 300px"></div>
  </dv-border-box-9>
</template>

<script>
import { getAction } from '@/api/manage'
export default {
  name: 'DeviceChartPerson',
  data() {
    return {
      barOption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: 55,
          top: 50,
          bottom: 30,
          right: 55,
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          show: false,
        },
        yAxis: {
          type: 'category',
          data: ['桥梁', '隧道', '边坡', '地铁', '基坑', '地灾', '建筑物', '水库大坝', '尾矿库'],
          axisLabel: {
            color: '#96BBDA',
            fontWeight: 'bold',
          },
          axisLine: {
            lineStyle: {
              color: '#0091F2',
            },
          },
        },
        series: [
          {
            name: '',
            type: 'bar',
            barMinHeight: 108,
            label: {
              show: true,
              position: 'insideLeft',
            },
            barWidth: 20,
            data: [23, 61, 100, 200, 123, 120, 320, 120, 89],
          },
        ],
      },
      url: {
        typeCount: '/show/bigScreen/getDeviceCountList',
      },
      projectId: null,
    }
  },
  async mounted() {},
  methods: {
    // 重新加载数据
    reloadData(projectId) {
      this.projectId = projectId
      this.loadData()
    },
    // 加载数据 渲染视图
    async loadData() {
      if (!this.projectId) {
        return
      }
      const result = await this.getTypeCount()
      const { list = [] } = result.result
      this.setRenderBarData(list, this.barOption)
      // 渲染图表
      const barChart = this.$echarts.init(this.$refs.barChart)
      barChart.setOption(this.barOption)
    },
    /**
     * @description: 获取服务数据
     * @param {undefined}
     * @return {Promise}
     */
    async getTypeCount() {
      // 172
      return await getAction(this.url.typeCount + '?projectId=' + this.projectId)
    },
    /**
     * @description: 设置条形图渲染数据
     * @param {list: Array, op: Object}
     * @return {undefined}
     */
    setRenderBarData(list, op) {
      console.log(list)
      const yData = list.map((item) => item.name)
      const xData = list.map((item) => item.count)
      op.yAxis.data = yData
      op.series[0].data = xData
    },
  },
}
</script>

<style lang='less' scoped>
.title {
  text-align: center;
  margin: 0;
  padding-top: 18px;
  color: #96bbda;
  font-size: 24px;
  font-weight: 500;
}
.border-box-content {
  padding: 24px;
}
</style>
